import { useTheme } from '@mui/material/styles';

export interface ChartColors {
  primary: string;
  secondary: string;
  success: string;
  warning: string;
  error: string;
  info: string;
  grid: string;
  text: string;
  textSecondary: string;
}

/** Chart libraries take raw color strings, so this is the one sanctioned theme read outside `styled`. */
export const useChartColors = (): ChartColors => {
  const { palette } = useTheme();
  return {
    primary: palette.primary.main,
    secondary: palette.secondary.main,
    success: palette.success.main,
    warning: palette.warning.main,
    error: palette.error.main,
    info: palette.info.main,
    grid: palette.grey[200],
    text: palette.text.primary,
    textSecondary: palette.text.secondary,
  };
};
